import React from 'react';
import { Outlet, useLocation } from 'react-router';
import { REWARD_ROUTE, SURVEY_ROUTE, SUPPORT_ROUTE } from '../constants';
import { Sidebar } from '../sidebar';
import { HeaderContextProvider } from '../header';
import { ExtensionContextProvider } from '../extension';
import { Footer } from '../footer';
import { SurveyContextProvider } from '../survey';

const LIGHT_MODE : string[] = [
    REWARD_ROUTE.MAIN,
    SURVEY_ROUTE.MAIN,
    SUPPORT_ROUTE.MAIN,
]

const AppLayout = () => {
    const location = useLocation();
    const isLight = LIGHT_MODE.includes(location.pathname);

    return (
        <div className="layout">
            <Sidebar light={isLight} />
            <div className="page-area">
                <ExtensionContextProvider>
                    <main className={`main ${isLight ? 'light-mode' : ''}`}>
                        <HeaderContextProvider>
                            <SurveyContextProvider>
                                <Outlet />
                            </SurveyContextProvider>
                        </HeaderContextProvider>
                        <Footer />
                    </main>
                </ExtensionContextProvider>
            </div>
        </div>

    );
};

export default AppLayout;